'use strict';

module.exports = function compact(array) {
  if (!Array.isArray(array)) {
    return [];
  }

  return array.filter(Boolean);
};



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/functions/compact.js
// module id = 55
// module chunks = 0